'use strict';

var _extends = require('../../../node_modules/@babel/runtime/helpers/extends.js');
var React = require('react');
var makeStyles = require('../../Styles/makeStyles.js');
require('prop-types');
var Typography = require('../../DataDisplay/Typography/Typography.js');
var Link = require('../../../node_modules/@material-ui/core/esm/Link/Link.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var useStyles = makeStyles["default"](function (theme) {
  return {
    breadcrumbsItem: {
      color: theme.palette.secondary.main,
      '&:hover': {
        color: theme.palette.primary.main,
        cursor: 'pointer'
      }
    }
  };
});

var BreadcrumbsItem = function BreadcrumbsItem(_ref) {
  var to = _ref.to,
      href = _ref.href,
      routerLink = _ref.routerLink,
      isLastItem = _ref.isLastItem,
      children = _ref.children;

  var _useStyles = useStyles(),
      breadcrumbsItem = _useStyles.breadcrumbsItem;

  var LinkRouter = function LinkRouter(props) {
    return routerLink ? React__default["default"].createElement(Link["default"], _extends["default"]({}, props, {
      to: to,
      component: routerLink
    })) : React__default["default"].createElement(Link["default"], _extends["default"]({}, props, {
      href: href
    }));
  };

  if (isLastItem) {
    return React__default["default"].createElement(Typography, {
      variant: "caption",
      color: "textPrimary"
    }, children);
  }

  return React__default["default"].createElement(Typography, {
    variant: "caption"
  }, React__default["default"].createElement(LinkRouter, {
    className: breadcrumbsItem,
    underline: "none"
  }, children));
};

BreadcrumbsItem.defaultProps = {
  to: null,
  href: null,
  routerLink: null,
  isLastItem: false
};
var BreadcrumbsItem$1 = React.memo(BreadcrumbsItem);

module.exports = BreadcrumbsItem$1;
